import React, { useState,useEffect, useContext } from "react";
import './candidateList.scss';
import { LuSearch } from "react-icons/lu";
import { CandidateForm } from "../../components/candidateForm/candidateForm";
import { IoGridOutline, IoListOutline } from "react-icons/io5";
import { ListView } from "../../components/candidatesView/ListView";
import { GridView } from "../../components/candidatesView/GridView";
import { useHeaderTitle } from '../../components/layout/layout';
import { FunctionalityNames } from "../../enum/enum";
import { getPermissionRights} from "../../utils/common";
import { AuthContext } from "../../context/AuthContext";
import { OverviewCount } from "../dashboard/overviewcount";
import jobApi from "../../services/jobApi";
import masterApi from "../../services/masterApi";


export default function CandidateList() {
    const REACT_APP_SEARCH_TEXT_LIMIT = process.env.REACT_APP_SEARCH_TEXT_LIMIT;

    const { rolePermissions } = useContext(AuthContext);
    const [candidateListPerm, setCandidateListPerm] = useState({});

    const { setHeaderTitle } = useHeaderTitle();   
    const [isPopupupVisible, setIsPopupupVisible] = useState(false);
    const [selectedTab, setSelectedTab] = React.useState("listView");
    const [searchText, setSearchText] = useState("");
    const [debouncedSearchText, setDebouncedSearchText] = useState("");
    const [refresh, setRefresh] = useState(false);
    const [candidateBoardStatus, setCandidateBoardStatus] = useState(null);
    const [jobsOverviewCount, setJobsOverviewCount] = useState(null)
    const [tagStatus, setTagStatus] = useState(null);
    const [tagsLst, setTagsLst] = useState([]);
    let tagsformattedData = [];
    const [boardStateLst, setBoardStateLst] = useState([]);

   
    const showPopup = () => {
        setIsPopupupVisible(true);
    };

    const hidePopup = () => {
        setIsPopupupVisible(false);
    };

    const handleEditClick = () => {
        setIsPopupupVisible(true);
    }

    const handleBoardStateChange = (selectedValue) => {
        if(selectedValue === "0") {
            setCandidateBoardStatus(null);
        }
        else{
            setCandidateBoardStatus(selectedValue);
        }
    }

    const handleTagChange = (e) => {
        if(e.target.value === "All") {
            setTagStatus(null);
        }
        else{ 
            setTagStatus(e.target.value);
        }
    }

    const handleInputChange = (e) => setSearchText(e.target.value);

    useEffect(() => {
        const fetchBoards = async () => {
            try {
                const boardResponse = await masterApi.getActiveBoard();
                if (boardResponse?.data?.ok) {
                    setBoardStateLst(boardResponse.data.activeboards);
                }
                console.log(boardResponse);
            } catch (error) {
                console.error("Failed to fetch boards:", error);
            }
        };
    
        fetchBoards();

    }, [candidateBoardStatus]);

    // const fetchData = async () => {debugger;
    //     const boardResponse = await masterApi.getActiveBoard();
    //     if(boardResponse?.data?.ok)  {      
    //         setBoardStateLst(boardResponse?.data?.activeboards);
    //     }
    //     console.log(boardResponse); 
    // };

    useEffect(() => {
            setHeaderTitle("Candidate List");
           
        }, [setHeaderTitle]);
    useEffect(() => {
        if (searchText.length >= REACT_APP_SEARCH_TEXT_LIMIT) { // Check if the length is at least 3
            const handler = setTimeout(() => {
                setDebouncedSearchText(searchText);
            }, 500); // 500ms delay

            // Cleanup timeout if the component re-renders or unmounts
            return () => {
                clearTimeout(handler);
            };
        } else {
            setDebouncedSearchText(""); // Optionally reset to an empty string if text length is below 3
        }
    }, [searchText]);
    const reloadData = () => {
        setRefresh((prev) => !prev); // Toggles state to force re-fetch
      };
    useEffect(() => { 
        if (rolePermissions) {
            setCandidateListPerm(getPermissionRights(rolePermissions, FunctionalityNames.CANDIDATE));
        }
    }, [rolePermissions]);

    const loadTags = async () => {
          try {
            const response = await masterApi.getActiveTags();
            // Transform the data
            tagsformattedData = response?.data?.activeTagsList?.map((tag) => ({
              label: tag.tagTitle,
              value: tag.id
            }));
            setTagsLst(tagsformattedData);
          } catch (error) {
            console.error("Error loading tags:", error);
            setTagsLst([]);
          }
        };

        useEffect(() => {   
            const loadData = async () => {
                try {
                    loadTags(); 
                } catch (error) {
                    console.error("Error loading data:", error);
                }
            }
        const fetchAll = async () => {
            await loadData();
          };
          fetchAll();
          }, []);

    return candidateListPerm?.view === 1 && (
        <section>
            <section className="d-flex w-100">
                <OverviewCount refresh={reloadData}/>
            </section>
            <section className="tool-bar d-flex align-items-center mb-3 gap-3">
                <div>
                    <div className="d-flex gap-3 align-items-center">
                        {/* <select className="form-select w-180" aria-label="account" onChange={handleStateChange}>
                            <option defaultValue>Status</option>
                            <option value="open">Open</option>
                            <option value="closed">Closed</option>
                            <option value="hold">On Hold</option>
                        </select> */}

                        <select className="form-select w-180" aria-label="account" onChange={(e) => handleBoardStateChange(e.target.value)}>
                            <option key="State" value="0">All</option>
                            {boardStateLst?.map((bState) => (
                                <option key={bState.id} value={bState.id}>
                                    {bState.boardName}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
                <div>
                    <div className="d-flex gap-3 align-items-center">
                        <select className="form-select w-180" aria-label="account" onChange={handleTagChange}>
                            <option defaultValue>All</option>
                            {tagsLst.map(tag => (
                                <option key={tag.value} value={tag.value}>
                                    {tag.label}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="ms-auto">
                    <div className="d-flex gap-2 align-items-center">
                        <div className='tabMenu icon-tab d-flex'>
                            <div
                                className={`tabButton d-flex align-items-center py-2 px-3 ${selectedTab === "listView" ? "active" : ""}`}
                                onClick={() => setSelectedTab("listView")} title="List View">
                                <IoListOutline />
                            </div>
                            <div
                                className={`tabButton d-flex align-items-center py-2 px-3 ${selectedTab === "tileView" ? "active" : ""}`}
                                onClick={() => setSelectedTab("tileView")} title="Grid View">
                                <IoGridOutline />
                            </div>

                        </div>
                        <div className="input-group search-container">
                            <input type="text" className="form-control" placeholder='Search' value={searchText} 
                                onChange={handleInputChange} />
                            <button type="button" className="btn plain-btn-secondary"><LuSearch /></button>
                        </div>
                        {candidateListPerm?.create === 1 && (
                        <button type="button" className="btn btn-primary d-flex" onClick={showPopup}>Create Profile</button>
                        )}
                        </div>
                </div>

            </section>

                <div className='tabContent'>
                    {selectedTab === "listView" && (
                        <section className="datatable-holder">
                        <div className='tab-inner dashboard-holder'>
                           {/* < ListView handleEditClick={handleEditClick} selectedTab = {selectedTab} searchText={debouncedSearchText} */}
                           < ListView handleEditClick={handleEditClick} selectedTab = {selectedTab} searchText={searchText}
                                      reloadData={reloadData} candidateBoardStatus={candidateBoardStatus} tagStatus={tagStatus}/>
                        </div>
                         </section>
                    )}
                    {selectedTab === "tileView" && (

                        <div className='tab-inner list-holder'>
                            {/* <GridView searchText={debouncedSearchText} reloadCandidateData={reloadData} */}
                            <GridView searchText={searchText} reloadCandidateData={reloadData}
                                      candidateBoardStatus={candidateBoardStatus}/>

                        </div>
                    )}
                </div>

           
            {isPopupupVisible && <CandidateForm closePopup={hidePopup} reloadData={reloadData}/>}
        </section>
    );
}
